<template>
  <section v-if="tasks.length" class="user-info-tasks-card">
    <h2 class="user-info-tasks-title">{{ $t('onboarding.user_info.tasks.title') }}</h2>

    <ul class="user-info-tasks-list">
      <li v-for="task in tasks" :key="task.id" class="user-info-task-item">
        <button type="button" class="user-info-task-button" @click="navigateToTask(task)">
          <span class="user-info-task-indicator" aria-hidden="true"></span>
          <span class="user-info-task-label">{{ $t(task.labelKey) }}</span>
        </button>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserInfoTasks } from '@/store/onboarding-store';

export default {
  computed: {
    ...mapGetters(['user']),
    tasks() {
      return getUserInfoTasks(this.user);
    },
  },
  methods: {
    getTaskSelector(task) {
      if (task.id === 'change_name') {
        return '.full-name-input';
      }

      if (task.id === 'add_phone_number') {
        return '.phone-number-input';
      }

      return null;
    },
    focusTaskField(task) {
      const selector = this.getTaskSelector(task);
      if (!selector) {
        return;
      }

      const target = document.querySelector(selector);
      if (!target) {
        return;
      }

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    navigateToTask(task) {
      if (this.$route && this.$route.name === task.routeName) {
        this.focusTaskField(task);
        return;
      }

      if (this.$router) {
        this.$router.push({ name: task.routeName });
      }
    },
  },
};
</script>

<style scoped>
.user-info-tasks-card {
  margin-top: 16px;
  margin-bottom: 24px;
  border: 1px solid black;
  border-radius: 8px;
  background: #fff;
  padding: 16px;
}

.user-info-tasks-title {
  margin: 0 0 10px;
  font-size: 18px;
  line-height: 1.3;
  font-weight: 700;
}

.user-info-tasks-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.user-info-task-item {
  padding-inline: 6px;
  border-radius: 8px;
}
.user-info-task-item:hover {
  background-color: #f5f5f5;
}

.user-info-task-button {
  width: 100%;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  text-align: left;
  cursor: pointer;
  color: inherit;
}

.user-info-task-indicator {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid #9e9e9e;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: transparent;
  flex: 0 0 18px;
}

.user-info-task-label {
  font-size: 15px;
  line-height: 1.3;
}
</style>
